// Core packages
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Third party packages
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';

// Custom packages
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss']
})
export class PublicHeaderComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  lang: string;

  constructor(
    public configService: ConfigService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router,
  ) {
    this.lang = this.cookieService.get('lang') || 'it';
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit() {
    const routeSubscription = this.route.params.subscribe((params) => {
      if (params.lang) {
        this.lang = params.lang;
      }
    });
    this.subscriptions.push(routeSubscription);
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Redirect user to the same current page but with the new
   * language
   *
   * @since 1.0.0
   */
  onSelectLang(newLang: string): void {
    let actualRoute = this.router.url;
    if (actualRoute[0] === '/') {
      actualRoute = this.router.url.substr(1);
    }
    const newRouteAry = actualRoute.split('/');
    newRouteAry[0] = newLang;
    const newUrl = newRouteAry.join('/');
    this.router.navigateByUrl(newUrl);
  }
}
